import React from 'react';

// Matrix-style SVG emoji components with glowing effects
export const MatrixGraduationCap = ({ className = "matrix-emoji-gold", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
    <path d="M6 12v5c3 3 9 3 12 0v-5"/>
  </svg>
);

export const MatrixCamera = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
    <circle cx="12" cy="13" r="4"/>
  </svg>
);

export const MatrixChart = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
  </svg>
);

export const MatrixTarget = ({ className = "matrix-emoji-red", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </svg>
);

export const MatrixPaperclip = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.64 16.2a2 2 0 0 1-2.83-2.83l8.49-8.49"/>
  </svg>
);

export const MatrixDownload = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7,10 12,15 17,10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

export const MatrixLightbulb = ({ className = "matrix-emoji-gold", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 21h6"/>
    <path d="M12 17a5 5 0 0 0 3-9H9a5 5 0 0 0 3 9z"/>
  </svg>
);

export const MatrixFile = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14,2 14,8 20,8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10,9 9,9 8,9"/>
  </svg>
);

export const MatrixLink = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.71"/>
  </svg>
);

export const MatrixEye = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

export const MatrixTrash = ({ className = "matrix-emoji-red", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="3,6 5,6 21,6"/>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/>
  </svg>
);

export const MatrixRefresh = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="23,4 23,10 17,10"/>
    <polyline points="1,20 1,14 7,14"/>
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
  </svg>
);

export const MatrixAdmin = ({ className = "matrix-emoji-gold", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Single Layer Sharp-Edged Shield using Golden Ratio proportions (φ = 1.618) */}
    <path d="M12 2L20.5 5.5L19.5 16.5L12 22L4.5 16.5L3.5 5.5L12 2z" 
          fill="currentColor" 
          fillOpacity="0.12" 
          stroke="currentColor" 
          strokeWidth="2"/>
    
    {/* Prominent Admin Approval Tick Mark */}
    <path d="M8.5 12L11 14.8L16.5 9" 
          stroke="currentColor" 
          strokeWidth="2.8" 
          fill="none" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
  </svg>
);

export const MatrixCelebration = ({ className = "matrix-emoji-gold", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Divine Victory Chalice - Perfect Golden Ratio Trophy */}
    {/* Main chalice bowl using φ (1.618) divine proportions */}
    <ellipse cx="12" cy="10.8" rx="8.2" ry="5.1" fill="currentColor" fillOpacity="0.12"/>
    <path d="M3.8 10.8c0 2.8 3.7 5.1 8.2 5.1s8.2-2.3 8.2-5.1" stroke="currentColor" strokeWidth="2.2"/>
    
    {/* Golden spiral ornate handles - fibonacci curves */}
    <path d="M3.8 8.9c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2" strokeWidth="2.0" fill="currentColor" fillOpacity="0.08"/>
    <path d="M20.2 8.9c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2" strokeWidth="2.0" fill="currentColor" fillOpacity="0.08"/>
    
    {/* Sacred geometry stem - φ proportioned height */}
    <rect x="9.8" y="15.9" width="4.4" height="3.2" rx="0.8" fill="currentColor" fillOpacity="0.18"/>
    <path d="M9.8 15.9h4.4v3.2c0 0.4-0.4 0.8-0.8 0.8h-2.8c-0.4 0-0.8-0.4-0.8-0.8v-3.2z" strokeWidth="1.6"/>
    
    {/* Divine proportion base - mathematical perfection */}
    <ellipse cx="12" cy="20.1" rx="5.4" ry="1.3" fill="currentColor" fillOpacity="0.22"/>
    <path d="M6.6 20.1c0 0.7 2.4 1.3 5.4 1.3s5.4-0.6 5.4-1.3" strokeWidth="1.8"/>
    
    {/* Perfect golden crown - divine authority symbol */}
    <path d="M12 2.2l-3.4 7.1 3.4-2.1 3.4 2.1-3.4-7.1z" fill="currentColor" fillOpacity="0.28"/>
    <path d="M12 2.2l-3.4 7.1M12 2.2l3.4 7.1M8.6 9.3l3.4-2.1M15.4 9.3l-3.4-2.1" strokeWidth="1.4"/>
    
    {/* Sacred center gem - universal harmony */}
    <circle cx="12" cy="8.2" r="0.9" fill="currentColor"/>
    <circle cx="12" cy="8.2" r="0.6" fill="currentColor" fillOpacity="0.7"/>
    
    {/* Golden ratio positioning victory gems */}
    <circle cx="9.1" cy="10.1" r="0.5" fill="currentColor" fillOpacity="0.85"/>
    <circle cx="14.9" cy="10.1" r="0.5" fill="currentColor" fillOpacity="0.85"/>
    <circle cx="12" cy="12.8" r="0.4" fill="currentColor" fillOpacity="0.75"/>
    
    {/* Fibonacci spiral celebration sparkles */}
    <g fill="currentColor" opacity="0.65">
      <circle cx="4.2" cy="4.2" r="0.7"/>
      <circle cx="19.8" cy="4.2" r="0.7"/>
      <circle cx="2.8" cy="16.8" r="0.5"/>
      <circle cx="21.2" cy="16.8" r="0.5"/>
      <circle cx="6.8" cy="1.8" r="0.4"/>
      <circle cx="17.2" cy="1.8" r="0.4"/>
    </g>
    
    {/* Divine victory rays - golden angle positioning (137.508°) */}
    <g stroke="currentColor" strokeWidth="1.2" opacity="0.6" fill="none">
      <path d="M12 2.2L11 0.5M12 2.2L13 0.5"/>
      <path d="M8.6 9.3L6.8 7.1M15.4 9.3L17.2 7.1"/>
      <path d="M3.8 8.9L1.5 7.8M20.2 8.9L22.5 7.8"/>
      <path d="M3.8 15.3L1.5 16.4M20.2 15.3L22.5 16.4"/>
    </g>
  </svg>
);

export const MatrixLock = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
    <circle cx="12" cy="16" r="1"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

export const MatrixDashboard = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7"/>
    <rect x="14" y="3" width="7" height="7"/>
    <rect x="14" y="14" width="7" height="7"/>
    <rect x="3" y="14" width="7" height="7"/>
  </svg>
);

export const MatrixClipboard = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
  </svg>
);

export const MatrixUser = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

export const MatrixCheckCircle = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
    <polyline points="22,4 12,14.01 9,11.01"/>
  </svg>
);

export const MatrixXCircle = ({ className = "matrix-emoji-red", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"/>
    <line x1="15" y1="9" x2="9" y2="15"/>
    <line x1="9" y1="9" x2="15" y2="15"/>
  </svg>
);

export const MatrixPlus = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="12" y1="5" x2="12" y2="19"/>
    <line x1="5" y1="12" x2="19" y2="12"/>
  </svg>
);

// Additional beautiful SVG emoji components using golden ratio principles

export const MatrixClock = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Perfect circle - symbol of time's eternal nature */}
    <circle cx="12" cy="12" r="9.5" fill="currentColor" fillOpacity="0.08" strokeWidth="2.0"/>
    <circle cx="12" cy="12" r="7.8" fill="currentColor" fillOpacity="0.12" strokeWidth="1.6"/>
    
    {/* Golden ratio positioned hour markers */}
    <g stroke="currentColor" strokeWidth="1.8" fill="currentColor" opacity="0.8">
      <circle cx="12" cy="3.2" r="0.6"/>
      <circle cx="20.8" cy="12" r="0.6"/>
      <circle cx="12" cy="20.8" r="0.6"/>
      <circle cx="3.2" cy="12" r="0.6"/>
    </g>
    
    {/* Time hands positioned at golden angle */}
    <path d="M12 12L12 7.5" strokeWidth="2.2" strokeLinecap="round"/>
    <path d="M12 12L15.5 12" strokeWidth="1.8" strokeLinecap="round"/>
    
    {/* Sacred center point */}
    <circle cx="12" cy="12" r="1.1" fill="currentColor"/>
    <circle cx="12" cy="12" r="0.7" fill="currentColor" fillOpacity="0.6"/>
  </svg>
);

export const MatrixLightning = ({ className = "matrix-emoji-gold", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Divine lightning bolt - φ proportioned energy */}
    <path d="M13 2L4.5 12.8h6.5l-1 8.2L18.5 11.2H12l1-9.2z" 
          fill="currentColor" fillOpacity="0.18" strokeWidth="2.0"/>
    <path d="M13 2L4.5 12.8M4.5 12.8h6.5M11 12.8l-1 8.2M10 21L18.5 11.2M18.5 11.2H12M12 11.2l1-9.2"/>
    
    {/* Golden ratio energy sparkles */}
    <g fill="currentColor" opacity="0.7">
      <circle cx="8.2" cy="6.8" r="0.5"/>
      <circle cx="15.8" cy="17.2" r="0.5"/>
      <circle cx="6.1" cy="15.4" r="0.4"/>
      <circle cx="17.9" cy="8.6" r="0.4"/>
    </g>
    
    {/* Divine energy rays */}
    <g stroke="currentColor" strokeWidth="1.0" opacity="0.6" fill="none">
      <path d="M13 2L14.2 0.8M13 2L11.8 0.8"/>
      <path d="M10 21L8.8 22.2M10 21L11.2 22.2"/>
    </g>
  </svg>
);

export const MatrixHeart = ({ className = "matrix-emoji-red", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Perfect heart using golden ratio curves */}
    <path d="M20.8 4.6c-1.8-1.8-4.7-1.8-6.5 0l-2.3 2.3-2.3-2.3c-1.8-1.8-4.7-1.8-6.5 0-1.8 1.8-1.8 4.7 0 6.5l8.8 8.8 8.8-8.8c1.8-1.8 1.8-4.7 0-6.5z" 
          fill="currentColor" fillOpacity="0.15" strokeWidth="2.0"/>
    
    {/* Inner heart chamber */}
    <path d="M18.2 6.2c-1.2-1.2-3.1-1.2-4.3 0L12 8.1l-1.9-1.9c-1.2-1.2-3.1-1.2-4.3 0-1.2 1.2-1.2 3.1 0 4.3L12 16.7l6.2-6.2c1.2-1.2 1.2-3.1 0-4.3z" 
          fill="currentColor" fillOpacity="0.25"/>
    
    {/* Sacred center */}
    <circle cx="12" cy="10.5" r="1.2" fill="currentColor" fillOpacity="0.8"/>
    <circle cx="12" cy="10.5" r="0.7" fill="currentColor"/>
    
    {/* Golden spiral decorative elements */}
    <g fill="currentColor" opacity="0.6">
      <circle cx="8.5" cy="7.8" r="0.4"/>
      <circle cx="15.5" cy="7.8" r="0.4"/>
      <circle cx="12" cy="13.2" r="0.3"/>
    </g>
  </svg>
);

export const MatrixShield = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Divine protection shield - perfect symmetry */}
    <path d="M12 1.8L20.2 4.6v7.2c0 5.1-3.2 9.6-8.2 11.4-5.0-1.8-8.2-6.3-8.2-11.4V4.6L12 1.8z" 
          fill="currentColor" fillOpacity="0.12" strokeWidth="2.2"/>
    
    {/* Inner protection layer */}
    <path d="M12 4.2L17.8 6.1v5.7c0 3.8-2.4 7.2-5.8 8.6-3.4-1.4-5.8-4.8-5.8-8.6V6.1L12 4.2z" 
          fill="currentColor" fillOpacity="0.18" strokeWidth="1.8"/>
    
    {/* Sacred protection symbol */}
    <circle cx="12" cy="11.5" r="3.2" fill="currentColor" fillOpacity="0.1" strokeWidth="1.5"/>
    <path d="M12 8.3L14.5 11.5L12 14.7L9.5 11.5L12 8.3z" 
          fill="currentColor" fillOpacity="0.9" strokeWidth="1.2"/>
    
    {/* Protection energy points */}
    <g fill="currentColor" opacity="0.7">
      <circle cx="12" cy="6.1" r="0.5"/>
      <circle cx="12" cy="16.9" r="0.5"/>
      <circle cx="7.8" cy="11.5" r="0.4"/>
      <circle cx="16.2" cy="11.5" r="0.4"/>
    </g>
  </svg>
);

export const MatrixStar = ({ className = "matrix-emoji-gold", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Perfect five-pointed star using golden ratio */}
    <path d="M12 2.2l2.9 6.1 6.9 0.8-5.1 4.8 1.3 6.8L12 17.8l-5.8 3.1 1.3-6.8L2.4 9.1l6.9-0.8L12 2.2z" 
          fill="currentColor" fillOpacity="0.15" strokeWidth="2.0"/>
    
    {/* Inner star chamber */}
    <path d="M12 5.8l1.8 3.7 4.1 0.5-3.0 2.9 0.8 4.1L12 15.2l-3.5 1.9 0.8-4.1L6.3 10.0l4.1-0.5L12 5.8z" 
          fill="currentColor" fillOpacity="0.25"/>
    
    {/* Sacred center */}
    <circle cx="12" cy="12" r="1.6" fill="currentColor" fillOpacity="0.8"/>
    <circle cx="12" cy="12" r="1.0" fill="currentColor"/>
    
    {/* Golden ratio sparkle points */}
    <g fill="currentColor" opacity="0.6">
      <circle cx="12" cy="7.2" r="0.4"/>
      <circle cx="16.8" cy="16.8" r="0.4"/>
      <circle cx="7.2" cy="16.8" r="0.4"/>
      <circle cx="17.5" cy="9.2" r="0.3"/>
      <circle cx="6.5" cy="9.2" r="0.3"/>
    </g>
  </svg>
);

export const MatrixMoney = ({ className = "matrix-emoji-gold", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Currency symbol with golden ratio proportions */}
    <circle cx="12" cy="12" r="9" fill="currentColor" fillOpacity="0.1" strokeWidth="2"/>
    <circle cx="12" cy="12" r="6.5" fill="currentColor" fillOpacity="0.15" strokeWidth="1.5"/>
    
    {/* Dollar sign with mathematical precision */}
    <path d="M12 6v1.5M12 16.5V18" stroke="currentColor" strokeWidth="2.5"/>
    <path d="M9.5 9a2.5 2.5 0 0 1 2.5-2.5h1a2.5 2.5 0 0 1 0 5h-2a2.5 2.5 0 0 1 0 5h1a2.5 2.5 0 0 1 2.5-2.5"
          fill="none" stroke="currentColor" strokeWidth="2"/>
    
    {/* Sacred geometry accents */}
    <g fill="currentColor" opacity="0.6">
      <circle cx="7.5" cy="8.5" r="0.4"/>
      <circle cx="16.5" cy="8.5" r="0.4"/>
      <circle cx="7.5" cy="15.5" r="0.4"/>
      <circle cx="16.5" cy="15.5" r="0.4"/>
    </g>
  </svg>
);

export const MatrixLocation = ({ className = "matrix-emoji-red", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Location pin with geometric precision */}
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" 
          fill="currentColor" fillOpacity="0.15" strokeWidth="2"/>
    
    {/* Inner location chamber */}
    <circle cx="12" cy="10" r="4" fill="currentColor" fillOpacity="0.25" strokeWidth="1.5"/>
    <circle cx="12" cy="10" r="2.5" fill="currentColor" fillOpacity="0.7"/>
    
    {/* Sacred center point */}
    <circle cx="12" cy="10" r="1" fill="currentColor"/>
    
    {/* Navigation points using golden ratio */}
    <g fill="currentColor" opacity="0.6">
      <circle cx="12" cy="6.8" r="0.3"/>
      <circle cx="15.2" cy="10" r="0.3"/>
      <circle cx="12" cy="13.2" r="0.3"/>
      <circle cx="8.8" cy="10" r="0.3"/>
    </g>
  </svg>
);

export const MatrixDocument = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Document outline with golden ratio */}
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" 
          fill="currentColor" fillOpacity="0.1" strokeWidth="2"/>
    <path d="M14 2v6h6" fill="currentColor" fillOpacity="0.2" strokeWidth="1.5"/>
    
    {/* Document content lines */}
    <path d="M7 13h10M7 17h10M7 9h6" stroke="currentColor" strokeWidth="1.5"/>
    
    {/* Sacred geometry markers */}
    <g fill="currentColor" opacity="0.7">
      <circle cx="7" cy="13" r="0.4"/>
      <circle cx="7" cy="17" r="0.4"/>
      <circle cx="7" cy="9" r="0.4"/>
    </g>
  </svg>
);

export const MatrixCheck = ({ className = "matrix-emoji-green", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Checkmark with perfect proportions */}
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="12" cy="12" r="9" fill="currentColor" fillOpacity="0.1" strokeWidth="2"/>
    
    {/* Energy field */}
    <circle cx="12" cy="12" r="6.5" fill="currentColor" fillOpacity="0.05" strokeWidth="1"/>
    
    {/* Confirmation points */}
    <g fill="currentColor" opacity="0.6">
      <circle cx="6.5" cy="12" r="0.4"/>
      <circle cx="17.5" cy="12" r="0.4"/>
      <circle cx="12" cy="6.5" r="0.4"/>
      <circle cx="12" cy="17.5" r="0.4"/>
    </g>
  </svg>
);

export const MatrixSearch = ({ className = "matrix-emoji-blue", size = "24" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={`inline-block ${className}`}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* Simple search lens */}
    <circle cx="11" cy="11" r="8"/>
    
    {/* Search handle */}
    <path d="m21 21-4.35-4.35"/>
  </svg>
);
